<template>
  <div class="content-wrapper">
    <div class="content">
      <h1>Merci d’avoir joué !</h1>
      <p>
        Retrouvez toutes les ressources citées et plus encore sur notre page
        dédiée.
      </p>
      <p>Le BCI reste à votre disposition!</p>
      <div class="address-wrapper">
        <address>
          <span>Bureau cantonal pour l’intégration des étrangers</span>
          <span>et la prévention du racisme</span>
          <span>Rue du Valentin 10, 1014 Lausanne</span>
          <span class="first-link link"
            ><a href="tel:+41213164959">+41 (0)21 316 49 59</a></span
          >
          <span class="link"
            ><a href="mailto:info.integration@vd.ch"
              >info.integration@vd.ch</a
            ></span
          >
          <span class="link"
            ><a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.vd.ch/integration"
              >www.vd.ch/integration</a
            ></span
          >
          <span class="link"
            ><a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.vd.ch/bci"
              >www.vd.ch/bci</a
            ></span
          >
        </address>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "./../bus";

export default {
  mixins: [],

  data() {
    return {
      found: false,
      session_id: "",
      link_to: "",
      name: "",
    };
  },
  computed: {
    env() {
      return process.env;
    },
  },
  mounted() {
    // const session = this.$cookies.get("bci_session");
    bus.$emit("quizIsFinished");
  },
};
</script>
